export const GDANSK_TICKET = "ticket";
export const GDANSK_PASS = "pass";

export const GDANSK_KIND_SINGLE_TICKET = "singleTicket";
export const GDANSK_KIND_BASIC_PASS = "basicPass";
export const GDANSK_KIND_BEARER_PASS = "bearerPass";
export const GDANSK_KIND_PASS_OPEN = "passOpen";
export const GDANSK_KIND_SWIMMING_TRACK = "swimmingTrack";

export const getTitleByProductKind = (productKind: string) => {
  switch (productKind) {
    case GDANSK_KIND_SINGLE_TICKET:
      return "Bilet jednorazowy";
    case GDANSK_KIND_BASIC_PASS:
      return "Karnet tradycyjny";
    case GDANSK_KIND_BEARER_PASS:
      return "Karnet na okaziciela";
    case GDANSK_KIND_PASS_OPEN:
      return "Karnet OPEN";
    case GDANSK_KIND_SWIMMING_TRACK:
      return "Bilet intruktorski";
    default:
      return "";
  }
};
